import { InjectionToken } from '@angular/core';
import { IMedicationService } from './medication-service.interface';

export const MEDICATION_SERVICE = new InjectionToken<IMedicationService>(
  'MEDICATION_SERVICE'
);
